import React from 'react';
import PropTypes from 'prop-types';

import styles from '../css/app.module.css';

const ProductCard = ({model, productId, pen, onClickActionBtn}) => {
  const selected = model.type === 'PEN' && productId === pen?.id;
  const selectedClass = selected ? ` ${styles.selected}` : '';
  const size = model.size === 'THICK' ? 70 : 35;

  return (
    <div className={`${styles.card}${selectedClass}`}>
      <div className={styles['card-body']}>
        {selected && <div className={styles['card-selected-label']}>&#10003;&nbsp;selected!</div>}

        <div className={styles['card-preview-container']} onClick={() => onClickActionBtn(productId, model)}>
          <p style={{fontSize: size, color: model.colorHex}}>⬤</p>
        </div>

        <div className={styles['card-title-container']}>
          <h4 className={styles['card-title']}>{model.title}</h4>
          <h5 className={styles['card-subtitle']}>{model.subtitle}</h5>
        </div>
      </div>
    </div>
  );
};

ProductCard.propTypes = {
  model: PropTypes.object.isRequired,
  productId: PropTypes.string.isRequired,
  onClickActionBtn: PropTypes.func.isRequired,
};

export default ProductCard;
